<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        View Options
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">

                    <div class="mb-3">
                        <div class="form-check">
                            <input :checked="view_options.show_description" @change="toggleDescription" type="checkbox" class="form-check-input" id="checkbox-show-description">
                            <label class="form-check-label" for="checkbox-show-description">Description</label>
                        </div>
                    </div><!-- /.form-group-material -->

                    <div class="mb-3">
                        <div class="form-check">
                            <input :checked="view_options.show_times" @change="toggleTimes" type="checkbox" class="form-check-input" id="checkbox-show-estimation">
                            <label class="form-check-label" for="checkbox-show-estimation">Estimation</label>
                        </div>
                    </div><!-- /.form-group-material -->

                    <div class="mb-3">
                        <div class="form-check">
                            <input :checked="view_options.show_technical_notes" @change="toggleTechnicalNotes" type="checkbox" class="form-check-input" id="checkbox-show-tech-notes">
                            <label class="form-check-label" for="checkbox-show-tech-notes">Technical Notes</label>
                        </div>
                    </div><!-- /.form-group-material -->

                    <div class="mb-3">
                        <div class="form-check">
                            <input :checked="view_options.show_testing_notes" @change="toggleTestingNotes" type="checkbox" class="form-check-input" id="checkbox-show-testing-notes">
                            <label class="form-check-label" for="checkbox-show-testing-notes">Testing Notes</label>
                        </div>
                    </div><!-- /.form-group-material -->

                    <div class="mb-3">
                        <div class="form-check">
                            <input :checked="view_options.show_recording" @change="toggleRecording" type="checkbox" class="form-check-input" id="checkbox-show-recording">
                            <label class="form-check-label" for="checkbox-show-recording">Recording</label>
                        </div>
                    </div><!-- /.form-group-material -->

                    <div class="row mt-4">
                        <div class="col-6">
                            <button @click="toggleExpand" type="button" class="btn btn-light w-100">
                                <i class="far fa-expand-alt"></i>
                                Expand Epics
                            </button>
                        </div>
                        <div class="col-6">
                            <button @click="toggleCollapse" type="button" class="btn btn-light w-100">
                                <i class="far fa-compress-alt"></i>
                                Collapse Epics
                            </button>
                        </div>
                    </div><!-- /.row -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import { SET_PROPERTY } from 'vx/mutations'
    import { Selectize, LaddaButton } from 'components/form/input'
    import Multiselect from 'vue-multiselect'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        extends: CModal,

        components: {
            LaddaButton,
            Multiselect
        },

        data() {
            return {
                groupsSelected: null,
                estimationOption: 'Any',
                estimationOptions: [
                    'Any',
                    'Missing Estimate',
                    'Estimated'
                ]
            }
        },

        computed: {
            ...mapState('groups', ['groups']),
            ...mapState('settings/userstories', ['view_options']),
        },

        methods: {
            ...mapMutations('settings/userstories', [SET_PROPERTY]),

            toggleCollapse () {
                this[SET_PROPERTY]({ property: 'view_options.collapsed', value: true })
            },

            toggleExpand () {
                this[SET_PROPERTY]({ property: 'view_options.collapsed', value: false })
            },

            toggleTimes () {
                this[SET_PROPERTY]({ property: 'view_options.show_times', value: (!this.view_options.show_times) })
            },

            toggleDescription () {
                this[SET_PROPERTY]({ property: 'view_options.show_description', value: (!this.view_options.show_description) })
            },

            toggleTechnicalNotes () {
                this[SET_PROPERTY]({ property: 'view_options.show_technical_notes', value: (!this.view_options.show_technical_notes) })
            },

            toggleTestingNotes () {
                this[SET_PROPERTY]({ property: 'view_options.show_testing_notes', value: (!this.view_options.show_testing_notes) })
            },

            toggleRecording () {
                this[SET_PROPERTY]({ property: 'view_options.show_recording', value: (!this.view_options.show_recording) })
            }
        }
    }
</script>